import {
	CONVERSION_DISPLAY_VALUE,
	RANGE_OPTION,
	RANGE_OPTION_SCALE,
} from "@/const/moveValue";
import { bodyStore } from "@/store/bodyStore";
import { selectingPartStore } from "@/store/partsStore";
import { BodyPart } from "@/types/design";

// カラーボール コンポーネントで使うロジックを提供します。
export default function usePartMove() {
	const { body, updateBody } = bodyStore();
	const { selectingPart } = selectingPartStore();

	const verticalParts = ["eyebrows", "eyeline", "eyes", "mouth"];
	const breadthParts = ["eyebrows", "eyeline", "eyes"];
	const rotateParts = ["eyebrows", "eyeline"];

	const isShowVertical = verticalParts.includes(selectingPart.partName);
	const isShowScale = verticalParts.includes(selectingPart.partName);
	const isShowBreadth = breadthParts.includes(selectingPart.partName);
	const isShowRotate = rotateParts.includes(selectingPart.partName);

	const getVerticalValue = () => {
		if (selectingPart.partId) {
			const part = body.find(
				(m: BodyPart) => m.partName === selectingPart.partName,
			);
			if (part && "positionY" in part.partStyle) {
				return -part.partStyle.positionY + CONVERSION_DISPLAY_VALUE;
			}
		}
		return RANGE_OPTION.defaultValue;
	};

	const getBreadthValue = () => {
		if (selectingPart.partId) {
			const part = body.find(
				(m: BodyPart) => m.partName === selectingPart.partName,
			);
			if (
				part &&
				"leftPositionX" in part.partStyle &&
				"rightPositionX" in part.partStyle
			) {
				return part.partStyle.rightPositionX + CONVERSION_DISPLAY_VALUE;
			}
		}
		return RANGE_OPTION.defaultValue;
	};

	const getRotateValue = () => {
		if (selectingPart.partId) {
			const part = body.find(
				(m: BodyPart) => m.partName === selectingPart.partName,
			);
			if (
				part &&
				"leftRotate" in part.partStyle &&
				"rightRotate" in part.partStyle
			) {
				return part.partStyle.leftRotate + CONVERSION_DISPLAY_VALUE;
			}
		}
		return RANGE_OPTION.defaultValue;
	};

	const getScaleValue = () => {
		if (selectingPart.partId) {
			const part = body.find(
				(m: BodyPart) => m.partName === selectingPart.partName,
			);
			if (part && "scale" in part.partStyle) {
				return part.partStyle.scale;
			}
		}
		return RANGE_OPTION_SCALE.defaultValue;
	};

	// 上下バーの変更時の処理
	const onVerticalChange = (value: number[]) => {
		const changedValue = value;
		const newBody = body.map((part: BodyPart) => {
			const selectingPartName = selectingPart.partName;
			const targetPart = body.find(
				(m: BodyPart) => m.partName === part.partName,
			);
			const isSetted = targetPart?.partId;
			if (
				isSetted &&
				selectingPartName === part.partName &&
				"positionY" in part.partStyle
			) {
				const updatedPartStyle = {
					...part.partStyle,
					positionY: -changedValue[0] + CONVERSION_DISPLAY_VALUE,
				};

				return {
					...part,
					partStyle: updatedPartStyle,
				};
			}
			return part;
		});
		updateBody(newBody);
	};

	// 左右バーの変更時の処理
	const onBreadthValueChage = (value: number[]) => {
		const changedValue = value;
		const newBody = body.map((part: BodyPart) => {
			const selectingPartName = selectingPart.partName;
			const targetPart = body.find(
				(m: BodyPart) => m.partName === part.partName,
			);
			const isSetted = targetPart?.partId;
			if (
				isSetted &&
				selectingPartName === part.partName &&
				"leftPositionX" in part.partStyle &&
				"rightPositionX" in part.partStyle
			) {
				const updatedPartStyle = {
					...part.partStyle,
					leftPositionX: -changedValue[0] + CONVERSION_DISPLAY_VALUE,
					rightPositionX: changedValue[0] - CONVERSION_DISPLAY_VALUE,
				};

				return {
					...part,
					partStyle: updatedPartStyle,
				};
			}
			return part;
		});
		updateBody(newBody);
	};

	// 回転バーの変更時の処理
	const onRotateValueChage = (value: number[]) => {
		const changedValue = value;
		const newBody = body.map((part: BodyPart) => {
			const selectingPartName = selectingPart.partName;
			const targetPart = body.find(
				(m: BodyPart) => m.partName === part.partName,
			);
			const isSetted = targetPart?.partId;
			if (
				isSetted &&
				selectingPartName === part.partName &&
				"leftRotate" in part.partStyle &&
				"rightRotate" in part.partStyle
			) {
				const updatedPartStyle = {
					...part.partStyle,
					leftRotate: changedValue[0] - CONVERSION_DISPLAY_VALUE,
					rightRotate: -changedValue[0] + CONVERSION_DISPLAY_VALUE,
				};

				return {
					...part,
					partStyle: updatedPartStyle,
				};
			}
			return part;
		});
		updateBody(newBody);
	};

	// 拡大縮小バーの変更時の処理
	const onScaleValueChage = (value: number[]) => {
		const changedValue = value;
		const newBody = body.map((part: BodyPart) => {
			const selectingPartName = selectingPart.partName;
			const targetPart = body.find(
				(m: BodyPart) => m.partName === part.partName,
			);
			const isSetted = targetPart?.partId;
			if (
				isSetted &&
				selectingPartName === part.partName &&
				"scale" in part.partStyle
			) {
				const updatedPartStyle = {
					...part.partStyle,
					scale: changedValue[0],
				};

				return {
					...part,
					partStyle: updatedPartStyle,
				};
			}
			return part;
		});
		updateBody(newBody);
	};
	const verticalValue = getVerticalValue();
	const breadthValue = getBreadthValue();
	const rotateValue = getRotateValue();
	const scaleValue = getScaleValue();

	return {
		isShowVertical,
		isShowBreadth,
		isShowRotate,
		isShowScale,
		getVerticalValue,
		getBreadthValue,
		getRotateValue,
		onScaleValueChage,
		onVerticalChange,
		onBreadthValueChage,
		onRotateValueChage,
		verticalValue,
		breadthValue,
		rotateValue,
		scaleValue,
	};
}
